import { roundNumberByDecimal } from './common'

const INCH_CM_CONVERSION_FACTOR = 2.54
const LBS_KG_CONVERSION_FACTOR = 2.20462

export const cmToInch = (centimeters: number | string, decimal?: number) => {
  const number = typeof centimeters === 'string' ? parseFloat(centimeters) : centimeters
  const inches = number / INCH_CM_CONVERSION_FACTOR
  return decimal ? roundNumberByDecimal(inches, decimal) : inches
}

export const inchToCm = (inches: number | string, decimal?: number) => {
  const number = typeof inches === 'string' ? parseFloat(inches) : inches
  const centimeters = number * INCH_CM_CONVERSION_FACTOR
  return decimal ? roundNumberByDecimal(centimeters, decimal) : centimeters
}

export const kgToLbs = (kilograms: number | string, decimal?: number) => {
  const number = typeof kilograms === 'string' ? parseFloat(kilograms) : kilograms
  const pounds = number * LBS_KG_CONVERSION_FACTOR
  return decimal ? roundNumberByDecimal(pounds, decimal) : pounds
}

export const lbsToKg = (pounds: number | string, decimal?: number) => {
  const number = typeof pounds === 'string' ? parseFloat(pounds) : pounds
  const kilograms = number / LBS_KG_CONVERSION_FACTOR
  return decimal ? roundNumberByDecimal(kilograms, decimal) : kilograms
}

export const formatDimensions = (
  // input dimensions are in cm
  dimensions: { height?: number | null; width?: number | null; depth?: number | null },
  decimal?: number,
  removeUnit?: boolean,
) => {
  const { height, width, depth } = dimensions
  const filteredMetricDimensions = [height, width, depth].filter((value) => value != null) // keep 0, filter null and undefined
  const metricString = filteredMetricDimensions
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    .map((value) => `${decimal !== undefined ? roundNumberByDecimal(value!, decimal) : value}${removeUnit ? "" : "cm"}`)
    .join(' x ')
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  const imperialString = filteredMetricDimensions.map((value) => `${cmToInch(value!, decimal)}${removeUnit ? "" : "in"}`).join(' x ')
  return {
    metric: metricString,
    imperial: imperialString,
    isEmptyDimension: filteredMetricDimensions.length === 0,
  }
}
